import {
  SUBJECTS_FETCH_REQUEST, SUBJECTS_FETCH_SUCCESS, SUBJECTS_FETCH_FAILURE,
  SUBJECT_CREATE_REQUEST, SUBJECT_CREATE_SUCCESS, SUBJECT_CREATE_FAILURE,
  SUBJECT_UPDATE_REQUEST, SUBJECT_UPDATE_SUCCESS, SUBJECT_UPDATE_FAILURE,
  SUBJECT_DELETE_REQUEST, SUBJECT_DELETE_SUCCESS, SUBJECT_DELETE_FAILURE,
  UNITS_FETCH_REQUEST, UNITS_FETCH_SUCCESS, UNITS_FETCH_FAILURE,
  UNIT_CREATE_REQUEST, UNIT_CREATE_SUCCESS, UNIT_CREATE_FAILURE,
  UNIT_UPDATE_REQUEST, UNIT_UPDATE_SUCCESS, UNIT_UPDATE_FAILURE,
  UNIT_DELETE_REQUEST, UNIT_DELETE_SUCCESS, UNIT_DELETE_FAILURE,
  TOPICS_FETCH_REQUEST, TOPICS_FETCH_SUCCESS, TOPICS_FETCH_FAILURE,
  TOPIC_CREATE_REQUEST, TOPIC_CREATE_SUCCESS, TOPIC_CREATE_FAILURE,
  TOPIC_UPDATE_REQUEST, TOPIC_UPDATE_SUCCESS, TOPIC_UPDATE_FAILURE,
  TOPIC_DELETE_REQUEST, TOPIC_DELETE_SUCCESS, TOPIC_DELETE_FAILURE,
  SUBJECTS_UNITS_RESET
} from "./SubjectsUnitsTypes";

// Subjects Reducer
const subjectsInitial = {
  subjects: [],
  loading: false,
  error: null,
  success: false,
  lastFetchedAt: null
};

export const subjectsReducer = (state = subjectsInitial, action) => {
  switch (action.type) {
    case SUBJECTS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case SUBJECTS_FETCH_SUCCESS:
      return { ...state, loading: false, subjects: action.payload, error: null, lastFetchedAt: Date.now() };
    case SUBJECTS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case SUBJECT_CREATE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case SUBJECT_CREATE_SUCCESS:
      return { ...state, loading: false, subjects: [...state.subjects, action.payload], success: true };
    case SUBJECT_CREATE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case SUBJECT_UPDATE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case SUBJECT_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        subjects: state.subjects.map(s => s.subjectId === action.payload.subjectId ? { ...s, ...action.payload } : s),
        success: true
      };
    case SUBJECT_UPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case SUBJECT_DELETE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case SUBJECT_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        subjects: state.subjects.filter(s => s.subjectId !== action.payload),
        success: true
      };
    case SUBJECT_DELETE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case SUBJECTS_UNITS_RESET:
      return subjectsInitial;

    default:
      return state;
  }
};

// Units Reducer
const unitsInitial = {
  units: [],
  loading: false,
  error: null,
  success: false,
  lastFetchedAt: null
};

export const unitsReducer = (state = unitsInitial, action) => {
  switch (action.type) {
    case UNITS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case UNITS_FETCH_SUCCESS:
      return { ...state, loading: false, units: action.payload, error: null, lastFetchedAt: Date.now() };
    case UNITS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UNIT_CREATE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case UNIT_CREATE_SUCCESS:
      return { ...state, loading: false, units: [...state.units, action.payload], success: true };
    case UNIT_CREATE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case UNIT_UPDATE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case UNIT_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        units: state.units.map(u => u.unitId === action.payload.unitId ? { ...u, ...action.payload } : u),
        success: true
      };
    case UNIT_UPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case UNIT_DELETE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case UNIT_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        units: state.units.filter(u => u.unitId !== action.payload),
        success: true
      };
    case UNIT_DELETE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case SUBJECTS_UNITS_RESET:
      return unitsInitial;

    default:
      return state;
  }
};

// Topics Reducer
const topicsInitial = {
  topics: [],
  loading: false,
  error: null,
  success: false,
  lastFetchedAt: null
};

export const topicsReducer = (state = topicsInitial, action) => {
  switch (action.type) {
    case TOPICS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case TOPICS_FETCH_SUCCESS:
      return { ...state, loading: false, topics: action.payload, error: null, lastFetchedAt: Date.now() };
    case TOPICS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case TOPIC_CREATE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case TOPIC_CREATE_SUCCESS:
      return { ...state, loading: false, topics: [...state.topics, action.payload], success: true };
    case TOPIC_CREATE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case TOPIC_UPDATE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case TOPIC_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        topics: state.topics.map(t => t.topicId === action.payload.topicId ? { ...t, ...action.payload } : t),
        success: true
      };
    case TOPIC_UPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case TOPIC_DELETE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case TOPIC_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        topics: state.topics.filter(t => t.topicId !== action.payload),
        success: true
      };
    case TOPIC_DELETE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case SUBJECTS_UNITS_RESET:
      return topicsInitial;

    default:
      return state;
  }
};
